/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, func, shape, arrayOf, string,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Toolbar from './Config/Toolbar';
import { DefaultTools } from './Config/Default';

const styles = (theme) => ({
    root: {
        position: 'relative',
        minWidth: 300,
        maxWidth: 300,
        [theme.breakpoints.down(1660)]: {
            maxWidth: 260,
            minWidth: 260,
        },
        [theme.breakpoints.down('xs')]: {
            marginLeft: '10%',
        },
    },
    textarea: {
        minWidth: 250,
        minHeight: 250,
        maxWidth: 300,
        maxHeight: 300,
        outline: 'none',
        border: `1px dashed ${theme.palette.cgc?.cgcTextBorderColor || '#111'}`,
    },
});

const CgcEditor = ({
    classes, handleStyle, style, toolbarProps,
}) => {
    const handleStyles = (type, value) => {
        const styleObj = { ...style };
        styleObj[type] = value;
        handleStyle(styleObj);
    };
    return (
        <div className={classes.root}>
            <Toolbar config={toolbarProps || DefaultTools} setStyle={handleStyles} />
        </div>
    );
};

CgcEditor.propTypes = {
    classes: object.isRequired,
    handleStyle: func,
    style: object.isRequired,
    toolbarProps: arrayOf(shape({
        max_char: string.isRequired,
        title: string.isRequired,
        family_name_cards: string.isRequired,
    })),
};

CgcEditor.defaultProps = {
    handleStyle: () => {},
    toolbarProps: null,
};

export default withStyles(styles)(CgcEditor);
